import styled, { css } from 'styled-components';

import { color, mixin, modalBorderRadius, zIndexValues } from 'utils/styles';
import Icon from 'components/Icon';
import pxToRem from 'assets/theme/functions/pxToRem';

const topBarOffset = pxToRem(55);

export const ScrollOverlay = styled.div`
  z-index: ${(props) => props.zIndex || zIndexValues.modal};
  position: fixed;
  top: ${topBarOffset};
  left: 0;
  height: 100%;
  width: 100%;
  min-width: 1320px;
`;

export const ClickableOverlay = styled.div`
  top: ${topBarOffset};
  height: calc(100% - ${topBarOffset});
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 100px;
`;

export const StyledModal = styled.div`
  display: inline-block;
  position: relative;
  z-index: ${(props) => props.zIndex || zIndexValues.modal3};
  height: ${(props) => props.height || 'auto'};
  min-height: ${(props) => props.minHeight || 'auto'};
  width: ${(props) => props.width || 'auto'};
  min-width: ${(props) => props.minWidth || 'auto'};
  background: ${(props) => (props.isPrevIssue ? '#D3D3D3' : '#fff')};

  // Center css
  max-width: ${(props) => props.width}px;
  vertical-align: middle;
  border-radius: ${modalBorderRadius.sm};
  ${mixin.boxShadowHeavy}

  // Conditionally apply top margin for isPrevIssue 
    margin-top: ${(props) => (props.isPrevIssue ? '10vh' : '0')};
`;

export const CloseIcon = styled(Icon)`
  position: absolute;
  font-size: 25px;
  color: ${color.textMedium};
  transition: all 0.1s;
  ${mixin.clickable}
  ${(props) => closeIconStyles[props.variant]}
`;

const closeIconStyles = {
  center: css`
    top: 10px;
    right: 12px;
    padding: 3px 5px 0px 5px;
    border-radius: 4px;
    &:hover {
      background: ${color.backgroundLight};
    }
  `,
  aside: css`
    top: 10px;
    right: -30px;
    width: 50px;
    height: 50px;
    padding-top: 10px;
    border-radius: 3px;
    text-align: center;
    background: #fff;
    border: 1px solid ${color.borderLightest};
    ${mixin.boxShadowMedium};
    &:hover {
      color: ${color.primary};
    }
  `,
};
